import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ChatbotModal } from './ChatbotModal';
import { useEmergencyMode } from './useEmergencyMode';
import styles from './ChatbotFab.module.css';

export function ChatbotFab() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const emergency = useEmergencyMode();

  // Hide FAB on the dedicated chat page
  if (pathname === '/chat') return null;

  const label = emergency ? '야간 응급 상담 열기' : '담당자 상담 열기';

  return (
    <>
      {open && <ChatbotModal onClose={() => setOpen(false)} />}
      <button
        type="button"
        className={`${styles.fab} ${open ? styles.fabOpen : ''} ${
          emergency ? styles.fabEmergency : ''
        }`}
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? '상담창 닫기' : label}
        aria-expanded={open}
      >
        <span className={styles.iconSwap}>
          {open ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M6 6l12 12M18 6L6 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          ) : (
            <SirenIcon />
          )}
        </span>
        {!open && <span className={styles.badge} aria-hidden="true" />}
      </button>
    </>
  );
}

function SirenIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {/* emission rays */}
      <path
        d="M12 2v2.6M4.2 5.2l1.9 1.9M19.8 5.2l-1.9 1.9M2 10h2.4M19.6 10H22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* dome */}
      <path d="M5.5 15.5a6.5 6.5 0 0 1 13 0v.5h-13v-.5Z" fill="currentColor" />
      {/* highlight */}
      <path
        d="M8.5 11.8c0.7-1.6 2.1-2.7 3.9-2.9"
        stroke="rgba(255,255,255,0.6)"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
      />
      {/* base */}
      <rect x="4" y="16" width="16" height="3.4" rx="1" fill="currentColor" />
    </svg>
  );
}
